<template>
	<div>
		<img
			v-if="$vuetify.breakpoint.mdAndUp"
			width="100%"
			src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_desktop_top.png"
		/>
		<img
			v-if="$vuetify.breakpoint.smAndDown"
			width="100%"
			src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_mobile_top.png"
		/>

		<div
			style="background-color: #E5E1E0; padding: 30px"
			v-if="$vuetify.breakpoint.mdAndUp"
		>
			<v-img
				src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_shared_discover.png"
				style="width: 60%; max-width: 750px"
				class="mx-auto"
			>
			</v-img>

			<v-container class="mt-5" style="max-width: 1200px">
				<v-row>
					<v-col
						cols="4"
						class="text-center infoblock px-8 col-separator
"
					>
						<div class="text">
							Discover a curated <br />
							showcase of our work at
						</div>
						<a
							href="https://www.sgpphotoagency.com/"
							target="_blank"
							class="link"
						>
							<span>SGPPHOTOAGENCY</span>
						</a>
					</v-col>
					<v-col
						cols="4"
						class="text-center infoblock px-8  col-separator
"
					>
						<div class="text">
							For any inquiries of information, <br />
							contact us at
						</div>
						<a href="mailto:produzione@sgpitalia.com" class="link">
							<span>produzione@sgpitalia.com</span>
						</a>
					</v-col>
					<v-col cols="4" class="text-center infoblock px-8">
						<div class="text">
							To access our full project <br />
							archive, please register at
						</div>
						<a href="https://www.sgpitalia.com/" target="_blank" class="link">
							<span>SGPITALIA</span>
						</a>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="text-center infoblock mt-5">
						<span class="text mr-2">Follow us on Instagram:</span>
						<a
							href="https://www.instagram.com/sgpitalia"
							target="_blank"
							class="link"
						>
							<span>@SGPITALIA</span>
						</a>
					</v-col>
				</v-row>
			</v-container>
		</div>

		<div
			style="background-color: #E5E1E0; padding: 30px"
			v-if="$vuetify.breakpoint.smAndDown"
		>
			<v-img
				src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_shared_discover.png"
				style="width: 90%;"
				class="mx-auto mb-5"
			>
			</v-img>

			<div class="text-center">
				<div class="infoblock mb-3">
					<span class="text">For any inquiries of information,
							contact us at
					</span>
					<br />
					<a href="mailto:produzione@sgpitalia.com" class="link">
						<span>produzione@sgpitalia.com</span>
					</a>
				</div>

				<div class="infoblock mb-3">
					<span class="text">Discover a curated
							showcase of our work at
					</span>
					<br />
					<a
						href="https://www.sgpphotoagency.com/"
						target="_blank"
						class="link"
					>
						<span>SGPPHOTOAGENCY</span>
					</a>
				</div>

				<div class="infoblock mb-3">
					<span class="text">To access our full project
							archive, please register at
					</span>
					<br />
					<a href="https://www.sgpitalia.com/" target="_blank" class="link">
						<span>SGPITALIA</span>
					</a>
				</div>

				<div class="infoblock">
					<span class="text">Follow us on Instagram:
					</span>
					<br />
					<a
						href="https://www.instagram.com/sgpitalia"
						target="_blank"
						class="link"
					>
						<span>@SGPITALIA</span>
					</a>
				</div>
			</div>
		</div>

		<img
			alt="Every Image is an Emotion"
			style="width: 100%"
			v-if="$vuetify.breakpoint.mdAndUp"
			src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_desktop_bottom.png"
		/>
		<img
			alt="Every Image is an Emotion"
			v-if="$vuetify.breakpoint.smAndDown"
			style="width: 100%"
			src="https://sgpphoto.blob.core.windows.net/sgpweb/Landing/sgp_landing_mobile_bottom.png"
		/>
	</div>
</template>
<script>
import { mapActions } from "vuex";

export default {
	name: "Cannes2025",
	methods: {
		...mapActions(["RemoveAppMargin"]),
	},
	mounted() {
		this.RemoveAppMargin(true);
	},
	beforeDestroy() {
		this.RemoveAppMargin(false);
	},
	data() {
		return {
			test: 0
		};
	}
};
</script>

<style scoped lang="scss">
.infoblock {
	.text {
		color: #4d4747;
		font-weight: 500;
	}
	.link {
		color: #ba3629;
		font-weight: 600;
	}
}
.col-separator {
	border-right: 1px solid white;
}
</style>
